import { render } from "./CardProductAdmin.vue?vue&type=template&id=1e635be1&scoped=true"
import script from "./CardProductAdmin.vue?vue&type=script&lang=js"
export * from "./CardProductAdmin.vue?vue&type=script&lang=js"

import "./CardProductAdmin.vue?vue&type=style&index=0&id=1e635be1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e635be1"]])

export default __exports__